/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Neat_Jay_WakeInputs */

const en_raw_neat_jay_wake = /** @type {(inputs: Raw_Neat_Jay_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned templates can be used by users to create a new peer feedback for themselves or managed users`)
};

const de_raw_neat_jay_wake = /** @type {(inputs: Raw_Neat_Jay_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesene Vorlagen können von den Nutzern verwendet werden, um ein neues Peer Feedback für sich oder verwaltete Nutzer anzulegen`)
};

/**
* | output |
* | --- |
* | "Assigned templates can be used by users to create a new peer feedback for themselves or managed users" |
*
* @param {Raw_Neat_Jay_WakeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const raw_neat_jay_wake = /** @type {((inputs?: Raw_Neat_Jay_WakeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Neat_Jay_WakeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_raw_neat_jay_wake(inputs)
	return de_raw_neat_jay_wake(inputs)
});